import { createSlice, createEntityAdapter } from '@reduxjs/toolkit';
import { reHydrateStore } from '../utils/local-storage';

const bookingAdapter = createEntityAdapter();

const slice = createSlice({
  name: 'ticketTypes',
  initialState:
    reHydrateStore('ticketTypes') || bookingAdapter.getInitialState(),
  reducers: {
    setTicketTypes: (state, { payload }) => ({ ...payload }),
    addTicket: bookingAdapter.upsertOne,
    removeTicket: bookingAdapter.removeOne,
    removeAllTickets: bookingAdapter.removeAll,
    setAllTickets: bookingAdapter.setAll,
    upsertManyTickets: bookingAdapter.upsertMany,
    removeManyTickets: bookingAdapter.removeMany,
  },
});

export const {
  setTicketTypes,
  addTicket,
  removeTicket,
  removeAllTickets,
  setAllTickets,
  upsertManyTickets,
  removeManyTickets,
} = slice.actions;

export const simpleSelectors = bookingAdapter.getSelectors();

export default slice.reducer;
